import { render, staticRenderFns } from "./companyDetails.vue?vue&type=template&id=ce2557dc&scoped=true"
import script from "./companyDetails.vue?vue&type=script&lang=js"
export * from "./companyDetails.vue?vue&type=script&lang=js"
import style0 from "./companyDetails.vue?vue&type=style&index=0&id=ce2557dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2557dc",
  null
  
)

export default component.exports